var _rect, _circle, _circle2, _circle3, _circle4, _rect2, _polygon, _path, _path2, _path3, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroneSoundMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UGV with muted speaker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 28,
    width: 28,
    height: 10,
    rx: 4,
    fill: "#BA0D0D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 41,
    r: 6,
    fill: "#BA0D0D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 41,
    r: 3,
    fill: "#f7ce46"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 41,
    r: 6,
    fill: "#BA0D0D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 41,
    r: 3,
    fill: "#f7ce46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 6,
    height: 9,
    rx: 1,
    fill: "#BA0D0D"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "20,8 20,23 27,26 27,5",
    fill: "#BA0D0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 10 Q32.5 14 29 18",
    fill: "none",
    stroke: "#BA0D0D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 7 Q36 14 31 21",
    fill: "none",
    stroke: "#BA0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 4 Q40 14 33 24",
    fill: "none",
    stroke: "#BA0D0D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 4,
    x2: 40,
    y2: 27,
    stroke: "#BA0D0D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroneSoundMute);
export default __webpack_public_path__ + "static/media/droneSoundMute.4cf5072870f8593f66a76585756cfe60.svg";
export { ForwardRef as ReactComponent };